export const GENERIC = {
  LOADING: 'LOADING',
  INIT_LOADING: 'INIT_LOADING',
  STOP_INIT_LOADING: 'STOP_INIT_LOADING',
  STOP_LOADING: 'STOP_LOADING',
  SUCCESS_TOAST: 'SUCCESS_TOAST',
  ERROR_TOAST: 'ERROR_TOAST',
  RESET_ALL_MESSAGES: 'RESET_ALL_MESSAGES',
  REDIRECT_ROUTE: 'REDIRECT_ROUTE',
  RESET_REDIRECT_ROUTE: 'RESET_REDIRECT_ROUTE',
  SET_HAMBURGER_VISIBILITY: 'SET_HAMBURGER_VISIBILITY',
  MANAGE_SIDEMENU_VISIBILITY: 'MANAGE_SIDEMENU_VISIBILITY',
  ALERT_NOTIFICATION: 'ALERT_NOTIFICATION',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
}